// extracted by mini-css-extract-plugin
module.exports = {"toggle":"_2IUeStKF4XjmwCJGQsDqzD","switchContainer":"WJlmhVesaE7CS2mny45XN","spacer":"_16KOYRqTCDZLXwB-k8obe3","switch":"_35K62SoWfLbLWPpbtLArll"};